import { useEffect, useState } from "react";
import { headerLinks } from "../data";
import { Link } from "gatsby";
import "./styles.scss";
import { useLocation } from "@reach/router";

const Desktop = ({ formLink, pathname }) => {
  const location = useLocation();
  const isSalesCourseInitial = pathname === "/sales-course/";
  const [isApplyBtnVisible, setApplyBtnVisibility] = useState(pathname === "/");
  const [isSalesCourse, setIsSalesCourse] = useState(isSalesCourseInitial);
  const [linkColor, setLinkColor] = useState(
    isSalesCourseInitial ? "#FFFFFF" : "#606060"
  );
  const [logoSrc, setLogoSrc] = useState(
    isSalesCourseInitial
      ? "https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/e9d233fb-9c08-4517-8357-587282525862/events/banner-upload/14i86yoa2pm83a2a9u.webp"
      : "https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y16fv8m1qdwai0.webp"
  );

  useEffect(() => {
    let applyBtnVisible = location.pathname === "/";
    setApplyBtnVisibility(applyBtnVisible);
    setIsSalesCourse(location.pathname === "/sales-course/");
    if (location.pathname === "/sales-course/") {
      setLinkColor("#FFFFFF");
      setLogoSrc(
        "https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/e9d233fb-9c08-4517-8357-587282525862/events/banner-upload/14i86yoa2pm83a2a9u.webp"
      );
    } else {
      setLinkColor("#606060");
      setLogoSrc(
        "https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y16fv8m1qdwai0.webp"
      );
    }
  }, [location.pathname]);

  return (
    <div className="desktop-nav-wrap">
      <nav className="desktop-nav">
        <div className="desktop-head-logo">
          <Link to={"/" + location?.search}>
            <img
              src={logoSrc}
              alt="Kraftshala"
              title="Kraftshala"
              placeholder="none"
              className="nav-log"
            />
          </Link>
        </div>
        <ul
          className={`desktop-nav__menu ${isSalesCourse ? "sales-course" : ""}`}
        >
          {headerLinks.map((link) => {
            return (
              <li key={link.id}>
                <a href={link.link ?? "/#"} style={{ color: linkColor }}>
                  {link.name}
                </a>

                {!!link.dropDown?.length && (
                  <ul>
                    {link.dropDown.map((innerLink) => {
                      return (
                        <li key={innerLink.id}>
                          {innerLink.link &&
                          innerLink.id != "career-placement" ? (
                            <Link
                              className={`link-to-${innerLink.id}`}
                              to={innerLink.link + location?.search}
                            >
                              {innerLink.name}
                            </Link>
                          ) : (
                            <Link
                              className={`link-to-${innerLink.id}`}
                              to={innerLink.link + location?.search}
                              target="_blank"
                            >
                              {innerLink.name}
                            </Link>
                          )}

                          {innerLink.innerLevel && (
                            <ul>
                              {innerLink.innerLevel.map((lastLink) => {
                                return (
                                  <li key={lastLink.id}>
                                    <Link to={lastLink.link + location?.search}>
                                      {lastLink.name}
                                    </Link>
                                    {lastLink.subinnerLevel && (
                                      <ul className="main-menu">
                                        {lastLink.subinnerLevel.map(
                                          (sublast) => {
                                            return (
                                              <li key={sublast.heading}>
                                                <div className="custom-menu">
                                                  {sublast.courses.map(
                                                    (course) => {
                                                      return (
                                                        <div
                                                          className="link-block"
                                                          key={course.id}
                                                        >
                                                          {sublast.courses.indexOf(
                                                            course
                                                          ) == 0 ? (
                                                            <span className="list-heading">
                                                              {sublast.heading}
                                                            </span>
                                                          ) : (
                                                            ""
                                                          )}
                                                          <div
                                                            className="actual-link"
                                                            key={course.id}
                                                          >
                                                            <Link
                                                              to={
                                                                course.link +
                                                                location?.search
                                                              }
                                                            >
                                                              {course.name}
                                                            </Link>
                                                            <span className="link-description">
                                                              {
                                                                course.description
                                                              }
                                                            </span>
                                                          </div>
                                                        </div>
                                                      );
                                                    }
                                                  )}
                                                </div>
                                              </li>
                                            );
                                          }
                                        )}
                                      </ul>
                                    )}
                                  </li>
                                );
                              })}
                            </ul>
                          )}

                          {innerLink.subinnerLevel && (
                            <ul className="main-menu">
                              {innerLink.subinnerLevel.map((sublast) => {
                                return (
                                  <li key={sublast.heading}>
                                    <div className="custom-menu">
                                      {sublast.courses.map((course) => {
                                        return (
                                          <div
                                            key={course.id}
                                            className="link-block"
                                          >
                                            {sublast.courses.indexOf(course) ==
                                            0 ? (
                                              <span className="list-heading">
                                                {sublast.heading}
                                              </span>
                                            ) : (
                                              ""
                                            )}
                                            <div
                                              className="actual-link"
                                              key={course.id}
                                            >
                                              <Link
                                                to={
                                                  course.link + location?.search
                                                }
                                              >
                                                {course.name}
                                              </Link>
                                              <span className="link-description">
                                                {course.description}
                                              </span>
                                            </div>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </li>
                                );
                              })}
                            </ul>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                )}
              </li>
            );
          })}
          {isApplyBtnVisible && (
            <li>
              {/* <a href={formLink} class="apply">Apply now</a> */}
              <a href="#home-pick-program" className="apply">
                Apply now
              </a>
            </li>
          )}
        </ul>
      </nav>
    </div>
  );
};

export default Desktop;
